import { useEffect, useState } from 'react';
import { useGcal } from '@geerd-nx/gcal';
import axios from 'axios';
import { ASSETS_API } from 'libs/shareable-views/env';

export default function usePlayableVideoUrl(video: string) {
  const [videoInfo, setVideoInfo] = useState({ url: '', isHls: false });
  const asset_service = axios.create({ baseURL: `${ASSETS_API}/api/video` });
  const { getSession } = useGcal();
  useEffect(() => {
    (async () => {
      if (video.startsWith('cloudflare://')) {
        // get signed post request
        const session = await getSession();
        const token = session.getAccessToken().getJwtToken();
        await asset_service
          .post(
            '/download-url',
            {
              uid: `${video.replace('cloudflare://', '')}`,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          )
          .then((res) => {
            setVideoInfo({
              url: res.data.videoUrl,
              isHls: true,
            });
            return res.data.videoUrl;
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        setVideoInfo({
          url: video,
          isHls: false,
        });
      }
    })();
  }, [video]);

  return videoInfo;
}
